'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themePropTypes = exports.styles = exports.modifierConfig = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _elements = require('../../elements');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n    border-left: 2px solid ' + theme.colors.brand.primary + ';\n  ';
  },

  flyout: function flyout() {
    return '\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  ';
  }
};

var styles = exports.styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  align-items: center;\n  border-left: 2px solid transparent;\n  color: ' + theme.colors.base.textLight + ';\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  height: 100%;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  min-height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(48) + ';\n  text-decoration: none;\n\n  &:hover {\n    background: ' + theme.colors.base.chrome000 + ';\n    text-decoration: underline;\n  }\n\n  span {\n    margin: ' + (0, _decisivUiUtils.px2rem)(4) + ' ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(4) + ' 0;\n  }\n';
};

var themePropTypes = exports.themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.shape.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuSubItemLink', (0, _styledComponents2.default)(_elements.NavLink), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/MenuSubItemLink.js
// module id = 720
// module chunks = 2